import { FindAccountantFormSummary } from './formData'

export const isSummaryFilled = (summary: FindAccountantFormSummary) =>
  Object.values(summary).findIndex((value) => !value) === -1
